<template>
	<div class="collapsible-panel-component" :class="[{'hide-handle-mobile': hideHandleOnMobile, 'fixed-position': fixedPosition},panelSize]">
		<div v-if="!panelRetracted || alwaysOpen" class="collapsible-panel" :class="panelSize" :style="fixedPosition && fixedTopOffset ? { top: fixedTopOffset } : {}">

			<i v-if="!alwaysOpen"  class="fa fa-times icon-button close-panel-button" v-on:click="retractPanel"></i>

			<div class="panel-inner">
				<slot name="panel"></slot>
			</div>
	
		</div>
		<div v-if="!alwaysOpen && externalToggle == null && panelRetracted" class="handle-open collapsible-panel-handle" v-on:click="panelRetracted = false" :style="fixedPosition && fixedTopOffset ? { top: fixedTopOffset } : {}">
			<template v-if="handleText">{{handleText}}</template>
			<i v-else class="fa fa-angle-right fa-2x"></i>
		</div>

		<div class="main-container" :class="{'panel-open': !panelRetracted || alwaysOpen, 'panel-closed': panelRetracted && !alwaysOpen}">
			<div class="heading-slot"><slot name="heading"></slot></div>
			<slot name="main"></slot>
		</div>
	</div>
</template>

<script>

export default {

	name: 'CollapsiblePanel',
	props: ["hideHandleOnMobile","alwaysOpen","handleText","externalToggle",
		"panelSize", //sm = 200px, md=250px, lg=300px, xl=350px, xxl=450px, xxxl=600px
		"fixedPosition", // when true, panel stays fixed to viewport instead of scrolling with container
		"fixedTopOffset" // when fixedPosition: top offset (e.g. "93px") to sit below top-menu + toolbar; defaults via --collapsible-panel-fixed-top or 93px
	],
	data() {
		return {
			panelRetracted: true,
			showHandle: true
		}
	},
	watch: {
		externalToggle() {
			this.panelRetracted = !this.externalToggle
		}
	},
	methods: {
		retractPanel() {
			this.panelRetracted = true
			this.$emit("panelRetract")
		}
	},
	created() {
		if (this.externalToggle)
			this.panelRetracted = !this.externalToggle
	}

}
</script>

<style type="text/css" scoped>

	.collapsible-panel-component {
		position: relative;
		display: flex;
		flex-direction: row;
		align-items: stretch;
		height: 100%;
		margin-top: -10px;
	}

	.main-container {
		max-width: calc(100% + 15px);
		flex-grow: 1;
		flex-shrink: 1;
		padding-left: 0;
		padding-right: 15px; 
		padding-top: 10px;
		width: 75%;
		background-color: white;
		margin-right: -15px;
		margin-left: 0;
		padding-bottom: 15px;
	}

	.main-container.panel-open {
		padding-left: 15px;
		width: calc(100% - 300px);
	}

	.main-container .heading-slot {
		margin-top: 4px;
	}

	.main-container.panel-closed {
		margin-left: -15px;
		padding-left: 15px;
		max-width: calc(100% + 30px);
	}

	.close-panel-button {
		position: absolute;
		top: 7px;
		right: 7px;
		z-index: 10;
	}

	.collapsible-panel {
		width: 300px;
		margin-left: -15px;
		margin-top: 0px;
		background-color: #f8f9fa;
		padding: 10px;
		position: relative;
		background-color: var(--background-light);
	}

	.collapsible-panel h5 {
		margin-bottom: 20px;
	}

	.collapsible-panel.sm {
		width: 200px;
	}

	.collapsible-panel.md {
		width: 250px;
	}

	.collapsible-panel.lg {
		width: 300px;
	}

	.collapsible-panel.xl {
		width: 350px;
	}

	.collapsible-panel.xxl {
		width: 450px;
	}

	.collapsible-panel.xxxl {
		width: 600px;
	}

	/* Fixed position: panel stays frozen to viewport below top-menu and toolbar (z-index below Toolbar 29 / MainMenu 45) */
	.collapsible-panel-component.fixed-position .collapsible-panel {
		position: fixed;
		left: 0;
		top: var(--collapsible-panel-fixed-top, 93px); /* 45px top-bar + 48px toolbar min */
		bottom: 0;
		z-index: 20;
		margin-left: 0;
	}

	.collapsible-panel-component.fixed-position .handle-open.collapsible-panel-handle {
		position: fixed;
		left: 0;
		top: var(--collapsible-panel-fixed-top, 93px);
		z-index: 21;
	}

	.collapsible-panel-component.fixed-position .main-container.panel-open {
		margin-left: 300px;
	}

	.collapsible-panel-component.fixed-position.sm .main-container.panel-open {
		margin-left: 200px;
	}

	.collapsible-panel-component.fixed-position.md .main-container.panel-open {
		margin-left: 250px;
	}

	.collapsible-panel-component.fixed-position.lg .main-container.panel-open {
		margin-left: 300px;
	}

	.collapsible-panel-component.fixed-position.xl .main-container.panel-open {
		margin-left: 350px;
	}

	.collapsible-panel-component.fixed-position.xxl .main-container.panel-open {
		margin-left: 450px;
	}

	.collapsible-panel-component.fixed-position.xxxl .main-container.panel-open {
		margin-left: 600px;
	}

	/* Above 1280px only: bump fixed panel and main content right of the main menu (250px full / 80px icons-only); below 1280px working area goes behind menu so no offset */
	@media (min-width: 1280px) {
		/* Full menu open (250px) */
		.menu-visible .collapsible-panel-component.fixed-position .collapsible-panel {
			left: 250px;
		}

		.menu-visible .collapsible-panel-component.fixed-position .handle-open.collapsible-panel-handle {
			left: 250px;
		}

		.menu-visible .collapsible-panel-component.fixed-position .main-container.panel-open {
			margin-left: 550px;
		}

		.menu-visible .collapsible-panel-component.fixed-position.sm .main-container.panel-open {
			margin-left: 190px;
		}

		.menu-visible .collapsible-panel-component.fixed-position.md .main-container.panel-open {
			margin-left: 240px;
		}

		.menu-visible .collapsible-panel-component.fixed-position.lg .main-container.panel-open {
			margin-left: 290px;
		}

		.menu-visible .collapsible-panel-component.fixed-position.xl .main-container.panel-open {
			margin-left: 340px;
		}

		.menu-visible .collapsible-panel-component.fixed-position.xxl .main-container.panel-open {
			margin-left: 440px;
		}

		.menu-visible .collapsible-panel-component.fixed-position.xxxl .main-container.panel-open {
			margin-left: 590px;
		}

		/* Icons-only menu (80px) – overrides full-menu when both classes present */
		.menu-icons-only .collapsible-panel-component.fixed-position .collapsible-panel {
			left: 80px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position .handle-open.collapsible-panel-handle {
			left: 80px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position .main-container.panel-open {
			margin-left: 380px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position.sm .main-container.panel-open {
			margin-left: 190px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position.md .main-container.panel-open {
			margin-left: 240px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position.lg .main-container.panel-open {
			margin-left: 290px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position.xl .main-container.panel-open {
			margin-left: 340px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position.xxl .main-container.panel-open {
			margin-left: 440px;
		}

		.menu-icons-only .collapsible-panel-component.fixed-position.xxxl .main-container.panel-open {
			margin-left: 590px;
		}
	}

	.handle-open.collapsible-panel-handle {
		left: -15px;
	}

	.collapsible-panel-handle {
		position: absolute;
		top: 0;
		z-index: 10;
		cursor: pointer;

    	font-size: 12pt;
		padding: 8px;
		background-color: #898781;
		color: #E0DAD7;
		border-bottom-right-radius: 5px;
		border-top-right-radius: 5px;
	}

	.collapsible-panel-handle:hover {
		color: white;
		background-color: #5f5d58;
	}

	.collapsible-panel .collapsible-panel-handle {
		position: absolute;
		right: -33px;
		top: 0px;
		box-shadow: none;
		border-radius: 0;

		border-left: 1px solid #a0a0a0;
		border-bottom: 1px solid #a0a0a0;
	}

	.collapsible-panel .collapsible-panel-card {
		margin-left: -10px;
		margin-right: -15px;
	} 

	.collapsible-panel .card-header {
		padding: 10px;
	}

	@media (max-width: 1024px) {
		.main-container.panel-open {
			width: calc(100% - 250px);
		}

		.collapsible-panel {
			width: 250px;
		}

		.collapsible-panel.sm {
			width: 200px;
		}

		.collapsible-panel.md,
		.collapsible-panel.lg,
		.collapsible-panel.xl,
		.collapsible-panel.xxl,
		.collapsible-panel.xxxl {
			width: calc(100% + 30px);
		}

		.md .main-container.panel-open,
		.lg .main-container.panel-open,
		.xl .main-container.panel-open,
		.xxl .main-container.panel-open,
		.xxxl .main-container.panel-open, {
			width: 100%;
		}

		.collapsible-panel-component.xl,
		.collapsible-panel-component.xxl,
		.collapsible-panel-component.xxxl {
			flex-direction: column;
		}

		.md .main-container.panel-closed,
		.lg .main-container.panel-closed,
		.xl .main-container.panel-closed,
		.xxl .main-container.panel-closed,
		.xxxl .main-container.panel-closed {
			padding-left: 15px;
    		margin-left: -15px;
			width: calc(100% + 30px);
		}
	}

	/* Under 1200px toolbar is no longer fixed, so disable fixed panel too */
	@media (max-width: 1199px) {
		.collapsible-panel-component.fixed-position .collapsible-panel {
			position: relative;
			left: auto;
			top: auto;
			bottom: auto;
			margin-left: -15px;
		}

		.collapsible-panel-component.fixed-position .handle-open.collapsible-panel-handle {
			position: absolute;
			left: auto;
			top: 0;
		}

		.collapsible-panel-component.fixed-position .main-container.panel-open,
		.collapsible-panel-component.fixed-position.sm .main-container.panel-open,
		.collapsible-panel-component.fixed-position.md .main-container.panel-open,
		.collapsible-panel-component.fixed-position.lg .main-container.panel-open,
		.collapsible-panel-component.fixed-position.xl .main-container.panel-open,
		.collapsible-panel-component.fixed-position.xxl .main-container.panel-open,
		.collapsible-panel-component.fixed-position.xxxl .main-container.panel-open {
			margin-left: 0;
			padding-left: 15px;
		}
	}

	@media (max-width: 767px) {

		.collapsible-panel-component {
			flex-direction: column;
		}

		.collapsible-panel {
			min-height: 0;
		}

		.main-container.panel-open .heading-slot {
			margin-left: 0px;
		}

		.fa-angle-left {
			transform: rotate(90deg);
			position: relative;
			left: -4px;
		}

		.fa-angle-right {
			transform: rotate(90deg);
		}

		.collapsible-panel .collapsible-panel-handle {
			padding-left: 20px;
			right: 0;
			border-right: none;
		}

		.hide-handle-mobile .collapsible-panel-handle {
			display: none;
		}

		.hide-handle-mobile .main-container .heading-slot {
			margin-left: -10px;
		}

		.handle-open.collapsible-panel-handle {
			left: auto;
			right: -15px;
			padding-left: 15px;
			padding-right: 15px;
			border-left: 1px solid #a0a0a0;
			border-right: none;
		}

		.main-container {
			left: 0;
			max-width: none;
		}

		.main-container.panel-open {
			width: calc(100% + 30px);
		}

		.main-container.panel-closed {
			width: calc(100% + 15px);
		}

		.md .main-container.panel-open,
		.lg .main-container.panel-open,
		.xl .main-container.panel-open,
		.xxl .main-container.panel-open,
		.xxxl .main-container.panel-open,
		.md .main-container.panel-closed,
		.lg .main-container.panel-closed,
		.xl .main-container.panel-closed,
		.xxl .main-container.panel-closed,
		.xxxl .main-container.panel-closed {
			padding-left: 15px;
    		margin-left: -15px;
			width: calc(100% + 30px);
		}

		.main-container.panel-open {
			display: block;
			margin-top: 20px;
			margin-left: -15px;
			padding-left: 15px;
			width: calc(100% + 30px);
		}

		.collapsible-panel, .collapsible-panel.sm, .collapsible-panel.md, .collapsible-panel.lg, .collapsible-panel.xl {
			display: block;
			width: calc(100% + 30px);
			height: auto;
		}

		.collapsible-panel .collapsible-panel-card {
			margin-left: 0;
			margin-right: 0;
			margin-bottom: 20px;
		}


		.collapsible-panel.xxl,
		.collapsible-panel.xxxl {
			width: calc(100% + 30px);
		}
	}
</style>